import { render, staticRenderFns } from "./UnsavedData.vue?vue&type=template&id=727b40ba&"
import script from "./UnsavedData.vue?vue&type=script&lang=js&"
export * from "./UnsavedData.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports